module.exports = __webpack_public_path__ + "assets/img/filter-square.cf8bbdb9.svg";